export enum FeeMethod {
    REGULAR = 'Regular',
    TIERED = 'Tiered'
}
